module.exports = __webpack_public_path__ + "img/12-2.d8ed30c0.png";